import noteContext from "./NoteContext";
import { useState } from "react";

const NoteState = (props) => {

    //get all notes

    const [authtoken, setauthtoken] = useState(localStorage.getItem("token"))

    const getallnotes = async () => {
        const response = await fetch("https://floatnotes.onrender.com/api/notes/fetchallnotes", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": authtoken
            },
        });
        const json = await response.json()
        setnotes(json)
    }

    //add a note
    const addnote = (title, description, tag) => {
        let note = { title, description, tag };
        setnotes(notes.concat(note))
    }

    //edit a note
    const editnote = async (id, title, description) => {

        let data = {
            title, description,
            "tag": "I am sdf a tag"
        }

        const response = await fetch(`https://floatnotes.onrender.com/api/notes/updatenote${id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "auth-token": authtoken
            },
            body: JSON.stringify(data),

        });

    }

    //delete a note

    const deletenote = async (id) => {
        let newnote = notes.filter((note) => { return note._id !== id })
        setnotes(newnote);


        const response = await fetch(`https://floatnotes.onrender.com/api/notes/deletenote${id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "auth-token": authtoken
            },
        });
        const json = await response.text()
        console.log(json)
    }

    const [notes, setnotes] = useState([]);

    return (
        <noteContext.Provider value={{ notes, addnote, editnote, deletenote, getallnotes, authtoken, setauthtoken }}>
            {props.children}
        </noteContext.Provider>
    )
}

export default NoteState